<template>
        <div>
            <app-header></app-header>
            <Row style="margin-top: 40px">
                <Col span="1">
                    &nbsp;
                </Col>
                <Col span="4">
                    <app-left></app-left>
                </Col>
                <Col span="15">
                    <div style="margin:0px auto;">
                      <div >
                            <Scroll :on-reach-bottom="handleReachBottom" :height="700" class="scrollWrap">
                                <Card v-for="(project, index) in list1" :key="project.projectId" style="margin: 100px 0"> 
                                    <p v-for="(userDetail, index) in userDetailList" v-if="project.creatorId == userDetail.userId">
                                        <Row>
                                            <Col span="4">
                                                    <span @click="userInformation(userDetail.userId)">
                                                        <a>{{userDetail.nickName}}</a>
                                                    </span>
                                            </Col>
                                            <Col span="6">
                                                <span @click="projectDetail(project.projectId, userDetail.userId)">
                                                    <a>{{project.projectName}}</a>
                                                </span>
                                            </Col>
                                             <Col span="2">
                                                {{dateFormat(project.creationTime)}}
                                            </Col>
                                        </Row>
                                    </p>
                                    <Row>
                                        <Col span="4">&nbsp;</Col>
                                        <Col span="10">{{project.projectDesc}}</Col>
                                    </Row>
                                    <Row>
                                        <br><br>
                                    </Row>
                                </Card>
                            </Scroll>
                      </div>    
                    </div>
                </Col>
                <Col span="4">
                    <div class="postmiddle-right" style="height: 700px;background-color: white;margin: 0px auto;text-align: center;">
                        <ul style="list-style: none;font-size: 16px;">
                            <li><a @click="createProject">创建项目</a></li>
                        </ul>
                    </div>
                </Col>
            </Row>
        </div>
</template>

<style>
    .scrollWrap {
      overflow-y: hidden;
}
</style>

<script>
  import Vue from 'vue'
  import config from '../../config.js'
  export default{   
    data(){
      return{
        list: [],
        list1: [],
        userDetailList:[],
        value1:'2',
        isLogin:false,
     }
   },
   created:function(){
    
   },
   mounted:function() {
        //页面加载时执行方法
        this.findProject();
      },
      methods: {
            findProject:function(){
                let url = config.baseUrl + "project/projectList";
                this.$http.get(url).then(function(successData){
                let that = this;
                let data = successData.data;
                let length = 3;
                that.list=data.result.projectList;
                that.userDetailList=data.result.userDetailList;
                for (let i=0; i < length; i++) {
                    that.list1.push(that.list[i]);
                }
             },function(errorData){
               this.$Message.error('Error!');
            });

            },
           handleReachBottom () {
                return new Promise(resolve => {
                    setTimeout(() => {
                        const listLength = this.list.length;
                        const listLength1 = this.list1.length;
                        if ((listLength - listLength1) != (listLength % 3)) {
                            for (let i = 1; i < 4; i++) {
                                this.list1.push(this.list[listLength1 - 1 + i]);
                            }
                        }else{
                            for (let i = 1; i < (listLength % 3) + 1; i++) {
                                this.list1.push(this.list[listLength1 - 1 + i]);
                            }
                            this.text = '数据已经到底了';
                        }
                        resolve();
                    }, 1000);
                });
            },
            dateFormat(time) {
                return formatDate(time);
            },
            iob:function(){
                this.$router.push({name:'home'})
            },
            project:function(){
                this.$router.go(0)
            },
            posting:function(){
                this.$router.push({name:'posting'})
            },
            //用户资料
            userInformation:function(userId){
                this.$router.push({name:'userInformation',params:{userId: userId}})
            },
            getAllTag:function(){
                let url = config.baseUrl + "tag/getAllTag";
                this.$http.get(url).then(function(successData){
                    let that = this;
                    let data = successData.data;
                    that.tagList = data;
                },function(errorData){
                    this.$Message.error("Load Fail!");
                });
            },
            gotoRegister:function(){
                this.$router.push({name:'register'})
            },
            gotoLogin:function(){
                this.$router.push({name:'login'})
            },
            projectDetail:function(projectId, userId){
                this.$router.push({name:'projectDetail',params:{projectId:projectId,userId:userId}});
            },
            createProject:function(){
                this.$router.push({name:'createProject'})
            },
        }

   }
 </script>


// WEBPACK FOOTER //
// Project.vue?46615ded